var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"newProducts"},_vm._l((_vm.newProductList),function(product){return _c('div',{key:product.id,staticClass:"product"},[_c('div',{staticClass:"product-pic"},[_c('router-link',{attrs:{"to":{
        name:'ProductInfo',
        params:{
          name:product.name,
          productObj:product
        }
      }}},[_c('img',{attrs:{"src":product.main_img}})])],1),_vm._v(" "),_c('div',{staticClass:"product-info"},[_c('router-link',{attrs:{"to":{
        name:'ProductInfo',
        params:{
          name:product.name,
          productObj:product
        }
      }}},[_c('p',{staticClass:"product-name"},[_vm._v(_vm._s(product.name))])]),_vm._v(" "),_c('div',{staticClass:"product-price"},[_c('span',{attrs:{"id":"product-price"}},[_vm._v("￥ "+_vm._s(product.price))])])],1)])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35afdf54","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/NewProducts.vue
// module id = null
// module chunks = 